import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-chart-popup',
  templateUrl: './chart-popup.component.html',
  styleUrls: ['./chart-popup.component.scss']
})
export class ChartPopupComponent {
  fullLayout: any;
  type: string=''
  tableData: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
   this.type=this.data.type
   
    if (this.type === 'chart') {
      this.fullLayout = {
        ...this.data.graph.layout,
        width: "100%",
        height: "100%",
      };
    }else if(this.type === 'table'){
      this.tableData=this.data.table
    }

  }
}
